module.exports = __webpack_public_path__ + "img/closeIcon.c29fb882.png";